document.addEventListener('DOMContentLoaded', function () {
  const headerHand1 = document.querySelector('.header_hand1');

  let rotateValue = 0;
  let rotateDirection = 1; // Kierunek rotacji: 1 dla zgodnego zegara, -1 dla przeciwnego zegara
  const rotationStep = 1; // Krok rotacji (zmniejsz lub zwiększ, aby dostosować prędkość)

  function rotateImage() {
    rotateValue += rotateDirection * rotationStep; // Zwiększ lub zmniejsz kąt rotacji w zależności od kierunku
    headerHand1.style.transform = `rotate(${rotateValue}deg)`;

    if (Math.abs(rotateValue) >= 35) { // Zmiana kierunku rotacji po osiągnięciu określonego kąta
      rotateDirection *= -1;
    }

    setTimeout(rotateImage, 200); // Opóźnij kolejny krok rotacji o 50 milisekund (możesz dostosować)
  }

  rotateImage();
});




document.addEventListener('DOMContentLoaded', function () {
  const headerHand1 = document.querySelector('.header_hand2');

  let rotateValue = 0;
  let rotateDirection = -1; // Kierunek rotacji: 1 dla zgodnego zegara, -1 dla przeciwnego zegara
  const rotationStep = 1; // Krok rotacji (zmniejsz lub zwiększ, aby dostosować prędkość)

  function rotateImage() {
    rotateValue += rotateDirection * rotationStep; // Zwiększ lub zmniejsz kąt rotacji w zależności od kierunku
    headerHand1.style.transform = `rotate(${rotateValue}deg)`;

    if (Math.abs(rotateValue) >= 15) { // Zmiana kierunku rotacji po osiągnięciu określonego kąta
      rotateDirection *= -1;
    }

    setTimeout(rotateImage, 500); // Opóźnij kolejny krok rotacji o 50 milisekund (możesz dostosować)
  }

  rotateImage();
});






import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Animacje dla pierwszej sekcji
const t1 = gsap.timeline({
  scrollTrigger: {
    trigger: ".gsap_videoWrapper",
    scrub: 0.1,
    anticipatePin: 0,
    start: "top +77",
    end: "bottom",
    pin: true,
    markers: false,
  },
});

t1.to(".gsap_video", {
  duration: 2,
  height: "calc(100vh - 77px)",
  width: "100%",
});




$(function () {
  $('.popup-btn').click(function () {
      $('.popup.active').removeClass('active');
  });
});